import React from "react";
import utils from "fantastic/lib/utils";

const SelectImageButton = ({ onClick, image = "none" }) => {
  const styles = {
    backgroundImage: utils.url(image)
  };
  return (
    <button
      className="btn btn-form background-settings__image-select"
      onClick={onClick}
    >
      {image && image !== "none" ? (
        <>
          <span className="background-settings__preview" style={styles}></span>
          <small>{ i18n.t('image_change') }</small>
        </>
      ) : (
        <>
          <i className="fa fa-image"></i>
          <small>{ i18n.t('image_select') }</small>
        </>
      )}
    </button>
  );
};

export default SelectImageButton;
